import React from "react";
import RadioButtonDefecto from "../../../../../Common/Components/RadioButtonDefecto2";
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';

const UsoCajeroAutomatico = ({ data, selectRadio }) => {
    const { GET_PARAMETRO_GENERAL, GET_USO_CAJERO_AUTOMATICO } = data;
    const acentoLetraAminuscula = ExpHelper.ConvertirCaracter("a");

    if (!GET_PARAMETRO_GENERAL) {
        return null;
    }

    if (!GET_PARAMETRO_GENERAL.SINOREDBANELCO) {
        return null
    }

    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Uso Cajeros Autom" + acentoLetraAminuscula + "ticos"}</label>

                {GET_USO_CAJERO_AUTOMATICO.map(item => {
                    const referencia = `GUCA-${item.Id}`;

                    return (
                        <RadioButtonDefecto
                            key={item.Id}
                            nombre={"GUCA"}
                            descripcion={item.Descripcion}
                            valor={item.Id}
                            checked={item.Checked}
                            referencia={referencia}
                            selectRadio={(valor) => selectRadio("GET_USO_CAJERO_AUTOMATICO", valor, item.Codigo)} />
                    );
                })}

                {data.ERROR_PRODUCT["seleccionoCajeroAutomatico"] == false &&
                    <label className="error">{"Debe seleccionar al menos un uso de cajeros autom" + acentoLetraAminuscula + "tico."}</label>}
            </div>
        </div>
    );
}

export default UsoCajeroAutomatico;